import { render, staticRenderFns } from "./myJoin.vue?vue&type=template&id=2bde79e1&scoped=true&"
import script from "./myJoin.vue?vue&type=script&lang=js&"
export * from "./myJoin.vue?vue&type=script&lang=js&"
import style0 from "./myJoin.vue?vue&type=style&index=0&id=2bde79e1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde79e1",
  null
  
)

export default component.exports